import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
	getConversation,
	getConversationId,
	getMessagesByUser,
	getUnreadMessage,
	postSendMessage,
} from '../../api/chatApi';

export const useSendMessage = (options) => {
	const queryClient = useQueryClient();

	return useMutation(postSendMessage, {
		...options,
		onSettled: ({ newMessage }) => {
			queryClient.invalidateQueries(['messages', newMessage?.conversationId]);
			queryClient.invalidateQueries(['conversation']);
		},
	});
};

export const useGetConversationOfUser = (options) => {
	return useQuery(['conversation'], () => getConversation(), {
		...options,
		// cacheTime: 0,
		select: ({ conversation }) => {
			return conversation;
		},
	});
};

export const useGetConversationId = (recieverId, options) => {
	return useQuery(['conversationId', recieverId], () => getConversationId(recieverId), {
		...options,
		cacheTime: 0,
		enabled: !!recieverId,
		select: ({ conversation }) => {
			return conversation?._id;
		},
	});
};

export const useGetUnreadMessage = (receiver, options) => {
	return useQuery(['chat_notification'], () => getUnreadMessage(receiver), {
		...options,
		select: ({ unreadMessage }) => {
			return unreadMessage;
		},
	});
};

export const useGetMessagesByUser = (conversationId, options) => {
	return useQuery(['messages', conversationId], () => getMessagesByUser(conversationId), {
		...options,
		enabled: !!conversationId,
		// cacheTime: 0,
		select: ({ messages }) => {
			const transformedData = messages?.map((data) => {
				const {
					_id,
					message,
					sender: {
						_id: senderId,
						fullname: { firstname, middlename, lastname },
						user_profile,
					},
					createdAt,
				} = data;

				return {
					_id,
					text: message,
					createdAt: new Date(createdAt),
					user: {
						_id: senderId,
						name: `${firstname} ${middlename} ${lastname}`,
						avatar: user_profile,
					},
				};
			});

			return transformedData.reverse();
		},
	});
};
